import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const fareProductApiRoutes = {
    list: apiDataManagerBaseURL + "fareproducts/",
    load: apiDataManagerBaseURL + "fareproducts/",
    create: apiDataManagerBaseURL + "fareproducts/",
    update: apiDataManagerBaseURL + "fareproducts/",
    delete: apiDataManagerBaseURL + "fareproducts/",
};

export class FareProductAPI {
    static list(provider = '') {
        const url = fareProductApiRoutes.list;

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static load(id) {
        const url = `${fareProductApiRoutes.load}${id}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static create(model, provider = '') {
        const url = fareProductApiRoutes.create;

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(model)
        });
    }

    static update(id, model) {
        const url = `${fareProductApiRoutes.update}${id}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(model)
        });
    }

    static delete(id, provider = '') {
        const url = `${fareProductApiRoutes.delete}${id}`;

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}



// WEBPACK FOOTER //
// ./src/api/datamanager/FareProductAPI.js